import { Injectable, inject } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Storage, list, ref, uploadBytesResumable } from '@angular/fire/storage';
import { OfficeService } from './office.service';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  officeService = inject(OfficeService);
  firestore: Firestore = inject(Firestore);
  storage = inject(Storage);

  constructor() {}

  // pushFileToStorage(fileUpload: FileUpload): Observable<number | undefined> {
  //   const filePath = `${this.basePath}/${fileUpload.file.name}`;
  //   const storageRef = this.storage.ref(filePath);
  //   const uploadTask = this.storage.upload(filePath, fileUpload.file);

  //   uploadTask
  //     .snapshotChanges()
  //     .pipe(
  //       finalize(() => {
  //         storageRef.getDownloadURL().subscribe(downloadURL => {
  //           fileUpload.url = downloadURL;
  //           fileUpload.name = fileUpload.file.name;
  //           this.saveFileData(fileUpload);
  //         });
  //       })
  //     )
  //     .subscribe();

  //   return uploadTask.percentageChanges();
  // }

  uploadFile(input: HTMLInputElement) {
    if (!input.files) return;

    const files: FileList = input.files;

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        const storageRef = ref(this.storage, this.officeService.officePath() + '/' + file.name);
        uploadBytesResumable(storageRef, file);
      }
    }
  }

  async getFileList(refPath: string = '') {
    const storageRef = ref(this.storage, this.officeService.officePath() + '/' + refPath);

    // Find all the prefixes and items.
    await list(storageRef, { maxResults: 100 })
      .then(res => {
        console.log('[storage] getFileList res ', { res, path: storageRef.fullPath });
        // res.prefixes.forEach(folderRef => {
        //   // All the prefixes under listRef.
        //   // You may call listAll() recursively on them.
        //   console.log('[storage] getFileList folderRef ', folderRef);
        // });
        // res.items.forEach(itemRef => {
        //   // All the items under listRef.
        //   console.log('[storage] getFileList itemRef ', itemRef);
        // });
      })
      .catch(error => {
        // Uh-oh, an error occurred!
        console.log('[storage] getFileList error ', error);
      });
  }
}
